import React from "react";
import { MDBNavbar, MDBNavbarBrand, MDBRow, MDBCol } from "mdbreact";
import Logo from "../../assets/testttt-03.svg";
import Avatar from "../../assets/avatar.jpg";
import SSL_LOGO from "../../assets/SSL_logo.jpg";
import Config from "../../config.json"
export default function Header() {
  return (
    <MDBNavbar
      color="light"
      dark
      expand="md"
      className="site-header d-flex  align-items-start"
    >
      <MDBNavbarBrand>
        {/* <strong className="white-text">Navbar</strong> */}
        <MDBRow className="d-block">
          <MDBCol sm={"5"} md={"3"}>
            <a href={Config.SITE_URL}>
              <img
                style={{ width: "670px", height: "66px", maxHeight: "187px" }}
                src={Logo}
                alt=""
                className="logo img-fluid"
              />
            </a>
          </MDBCol>
        </MDBRow>
      </MDBNavbarBrand>
      <img src={Avatar} alt="" className="avatar" />
      {/* <div className="my- d-block d-sm-none"></div> */}
      {/* waleed work */}
      <div id="navbar-ssl__logo">
        <img className="ssl__logo" src={SSL_LOGO} height="70" alt="" />
      </div>
      {/* waleed work end*/}
    </MDBNavbar>
  );
}
